// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/lazyload.js'; import './autoload/menu.js'; // eslint-disable-line
/* global ajax_object */

// Import local dependencies
import { scrollIntoViewWithOffset } from './utils/helpers';

// Import plugins
import 'jquery-match-height';
import 'slick-carousel';
// import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
// import ScrollOut from 'scroll-out';

// Import scripts from Custom ACF Gutenberg blocks
import '../gutenberg/blocks/acf-about-hero/index.js'; import '../gutenberg/blocks/acf-accordion/index.js'; import '../gutenberg/blocks/acf-ask-us/index.js'; import '../gutenberg/blocks/acf-example/index.js'; import '../gutenberg/blocks/acf-filter-gallery/index.js'; import '../gutenberg/blocks/acf-filter-news/index.js'; import '../gutenberg/blocks/acf-full-size-image-text/index.js'; import '../gutenberg/blocks/acf-gallery-hero/index.js'; import '../gutenberg/blocks/acf-gallery-slider/index.js'; import '../gutenberg/blocks/acf-google-maps/index.js'; import '../gutenberg/blocks/acf-home-hero-section/index.js'; import '../gutenberg/blocks/acf-home-sand-section/index.js'; import '../gutenberg/blocks/acf-leasing-blue-section/index.js'; import '../gutenberg/blocks/acf-leasing-form-section/index.js'; import '../gutenberg/blocks/acf-left-right-image/index.js'; import '../gutenberg/blocks/acf-our-team/index.js'; import '../gutenberg/blocks/acf-section-with-building-plan/index.js'; import '../gutenberg/blocks/acf-tabs-images/index.js'; import '../gutenberg/blocks/acf-three-boxes-sand-background/index.js'; import '../gutenberg/blocks/acf-two-sides-text/index.js'; // eslint-disable-line

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Set CSS variable for header height
 */
const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });
  $('.menu-item-has-children > a').on('click', function (e) {
    if ($(this).attr('href') === '#') {
      e.preventDefault();
      $(this).next('.submenu').slideToggle(300);
    }
  });

  function closeModal(modalSelector) {
    $(modalSelector).fadeOut();
    $('html,body').css('overflow', 'auto');
  }

  function openModal(modalSelector) {
    $(modalSelector).fadeIn();
    $('html,body').css('overflow', 'hidden');
  }

  $('.contact-us-popup .close, .tell-us-popup .close').on('click', function () {
    const modal = $(this).closest('.contact-us-popup, .tell-us-popup');
    closeModal(modal);
  });

  $('[class*="member-main-"]').on('click', function () {
    let classList = $(this).attr('class');
    let memberNumber = classList.match(/member-main-(\d+)/)[1];
    console.log(classList);
    console.log(memberNumber);
    $('.member-' + memberNumber).fadeIn();
  });

  $('.team-member-popup .close').on('click', function () {
    $(this).closest('.team-member-popup').fadeOut();
    $('html, body').css('overflow', 'auto');
  });

  $('a.button[href*="tell-us-popup"], a.button[href*="contact-us-popup"]').on(
    'click',
    function (e) {
      e.preventDefault();
      const href = $(this).attr('href');
      if (href.includes('tell-us-popup')) {
        openModal('.tell-us-popup');
      } else if (href.includes('contact-us-popup')) {
        openModal('.contact-us-popup');
      }
    }
  );
  $('header').on(
    'click',
    'a[href*="tell-us-popup"], a[href*="contact-us-popup"]',
    function (e) {
      e.preventDefault();
      const href = $(this).attr('href');
      if (href.includes('tell-us-popup')) {
        openModal('.tell-us-popup');
      } else if (href.includes('contact-us-popup')) {
        openModal('.contact-us-popup');
      }
    }
  );
  $('footer').on(
    'click',
    'a[href*="tell-us-popup"], a[href*="contact-us-popup"]',
    function (e) {
      e.preventDefault();
      const href = $(this).attr('href');
      if (href.includes('tell-us-popup')) {
        openModal('.tell-us-popup');
      } else if (href.includes('contact-us-popup')) {
        openModal('.contact-us-popup');
      }
    }
  );

  $('.filter-trigger').on('click', function (e) {
    e.preventDefault();
    $(this).toggleClass('active');
    $('.category-list-desktop').fadeToggle(300);
  });

  $('#desktop-filter-container a').on('click', function (e) {
    e.preventDefault();
    const $link = $(this);
    const categoryID = $link.data('category-id') || 'all';
    const $section = $link.closest('section');
    const postType = $section.data('post-type') || 'attachment';
    $section.find('#desktop-filter-container a').removeClass('active');
    $link.addClass('active');

    executeFilterAjax(
      categoryID,
      postType,
      $section.find('#ajax-gallery-wrapper')
    );
  });

  $('#gallery-category-select').on('change', function (e) {
    e.preventDefault();
    const $select = $(this);
    const categoryID = $select.val();
    const $section = $select.closest('section');
    const postType = $section.data('post-type') || 'attachment';
    executeFilterAjax(
      categoryID,
      postType,
      $section.find('#ajax-gallery-wrapper')
    );
  });

  function executeFilterAjax(categoryID, postType, $resultContainer) {
    const data = {
      action: 'filter_gallery_images',
      category_id: categoryID,
      post_type: postType,
      nonce: ajax_object.nonce,
    };

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: data,
      beforeSend: function () {
        $resultContainer.html('<p>Loading...</p>');
      },
      success: function (response) {
        if (response) {
          $resultContainer.html(response);
        } else {
          $resultContainer.html('<p>Nothing found.</p>');
        }
      },
      error: function (xhr, status, error) {
        console.error('AJAX Error:', status, error);
        $resultContainer.html('<p>Error.</p>');
      },
    });
  }

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  // ScrollOut({
  //   offset: function() {
  //     return window.innerHeight - 200;
  //   },
  //   once: true,
  //   onShown: function(element) {
  //     if ($(element).is('.ease-order')) {
  //       $(element)
  //         .find('.ease-order__item')
  //         .each(function(i) {
  //           let $this = $(this);
  //           $(this).attr('data-scroll', '');
  //           window.setTimeout(function() {
  //             $this.attr('data-scroll', 'in');
  //           }, 300 * i);
  //         });
  //     }
  //   },
  // });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (_, formId) {
    let target = document.getElementById(
      `gform_confirmation_wrapper_${formId}`
    );

    if (target) {
      scrollIntoViewWithOffset(target, 100);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // Preloader
  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  // Create CSS variable for header height
  setHeaderHeight();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  resizeVideo();

  // Create CSS variable for header height
  setHeaderHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
